import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import CursorMaus from "../../components/CursorMaus/CursorMaus";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";
import blogs from "../../api/blogs";
import "./BlogPage.scss";

const BlogPage = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <Fragment>
      <Helmet>
        <title>Blogs | Cash Flow Summit 2026</title>
        <meta
          name="description"
          content="Insights on cash flow management, automation, and strategies for entrepreneurs and business owners."
        />
        <meta
          name="keywords"
          content="cash flow management, cash flow automation, cash flow strategies, Cash Flow Summit"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={"Blogs"} pagesub={"Insights"} />
      <section className="blog-section blog-listing-page section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col col-lg-8">
              <div className="section-title text-center">
                <h2>Cash flow insights</h2>
                <p>
                  Practical ideas on management, automation, and growth—aligned
                  with what we cover at the summit.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {blogs.map((blog) => (
              <div
                className="col col-lg-4 col-md-6 col-12"
                key={blog.id}
              >
                <div className="blog-card">
                  <div className="image">
                    <img src={blog.screens} alt={blog.title} />
                    <span>{blog.catagory}</span>
                  </div>
                  <div className="content">
                    <ul className="date">
                      <li>{blog.create_at}</li>
                      <li>{blog.name}</li>
                    </ul>
                    <h2>
                      <Link
                        onClick={ClickHandler}
                        to={`/blog/${blog.slug}`}
                      >
                        {blog.title}
                      </Link>
                    </h2>
                    <div className="link">
                      <Link
                        onClick={ClickHandler}
                        to={`/blog/${blog.slug}`}
                      >
                        <span>Read more</span>
                        <i className="ti-arrow-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};

export default BlogPage;
